import Alpine from "alpinejs"
import Tooltip from "@ryangjchandler/alpine-tooltip"

Alpine.plugin(
    Tooltip.defaultProps({
        delay: 50,
        theme: "dark",
        interactive: true,
        offset: [0, -4],
        hideOnClick: "click",
        allowHTML: true,
        placement: "top",
        maxWidth: 300,
    }),
)

// Add tooltip data store to Alpine
Alpine.store("tooltip", {
    headline: "",
    copy: "",
    url: "",
    update(headline, copy, url) {
        this.headline = headline || ""
        this.copy = copy || ""
        this.url = url || ""
    },
    getCopyHtml() {
        return this.copy ? this.copy : ""
    },
})

Alpine.data("vaccinationPlan", (column) => ({
    openDialog: false,
    selectedColumns: [],
    initialColumn: column ?? null,
    init() {
        if (this.initialColumn !== null) {
            this.$nextTick(() => {
                this.highlightColumn(this.initialColumn)
            })
        }

        if (this.$refs.table) {
            this.$nextTick(() => {
                this.initializeTooltips()
                this.initializeVaccines()
            })

            const targetGroupTitle = this.$refs.table.querySelector(".targetgroup-title")
            if (targetGroupTitle) {
                Array.from(targetGroupTitle.cells).forEach((cell) => {
                    cell.addEventListener("pointerenter", (event) => {
                        this.handleColumnHover(event, true)
                    })
                    cell.addEventListener("pointerleave", (event) => {
                        this.handleColumnHover(event, false)
                    })
                })
            }
        }
    },

    initializeVaccines() {
        const vaccines = []
        const markers = Array.from(this.$refs.table.querySelectorAll(".marker"))
        markers.forEach((marker) => {
            const { vaccine } = marker.dataset
            if (!vaccine) {
                return
            }
            const persistedVaccine = vaccines.filter((persistedVaccine) => persistedVaccine.id === vaccine)
            if (persistedVaccine.length > 0) {
                persistedVaccine[0].markers.push(marker)
            } else {
                vaccines.push({ id: vaccine, markers: [marker] })
            }
        })
        vaccines.forEach((vaccine) => {
            console.log(vaccine);
            vaccine.markers.forEach((marker, i) => {
                if (i === 0) {
                    marker.classList.add("start")
                    return
                }
                if (i === vaccine.markers.length - 1) {
                    marker.classList.add("end")
                    return
                }
                marker.classList.add("middle")
            })
        })
    },

    initializeTooltips() {
        document.querySelectorAll("[data-headline]").forEach((cell) => {
            const headline = cell.dataset.headline
            const copy = cell.dataset.copy
            const url = cell.dataset.url
            const placement = cell.dataset.placement || "top"

            Alpine.bind(cell, {
                "x-tooltip"() {
                    return {
                        content: () => {
                            Alpine.store("tooltip").update(headline, copy, url)
                            return this.$root.querySelector('[x-ref="tooltipTemplate"]')?.innerHTML
                        },
                        onShow: () => {
                            Alpine.store("tooltip").update(headline, copy, url)
                        },
                        placement: placement,
                        appendTo: () => document.body,
                    }
                },
            })
        })
    },

    isColumnSelected(columnIndex) {
        return this.selectedColumns.includes(columnIndex)
    },

    highlightColumn(columnIndex) {
        const columns = this.selectNthColumn(columnIndex -1, this.$refs.table)
        this.clearSelections()
        this.selectedColumns.push(columnIndex)
        columns.forEach((column) => {
            column.classList.add("selected")
        })
    },

    selectColumn(event) {
        const { target } = event
        const columnIndex = target.cellIndex + 3 // Adjust for the first two columns
        if (columnIndex <= 2) {
            return
        }

        if (this.isColumnSelected(columnIndex)) {
            this.clearSelections()
            return
        }

        this.highlightColumn(columnIndex)
    },

    // Handle column hover highlighting
    handleColumnHover(event, isEntering) {
        const { target } = event
        const columnIndex = target.cellIndex + 3 // Adjust for the first two columns
        // Skip the first column
        if (columnIndex <= 2) return

        const cells = this.selectNthColumn(columnIndex - 1, this.$refs.table)
        cells.forEach((cell) => {
            if (isEntering) {
                cell.classList.add("hover-highlight")
            } else {
                cell.classList.remove("hover-highlight")
            }
        })
    },

    selectRow(event) {
        const clickedTh = event.target
        const clickedRow = clickedTh.closest("tr")

        if (clickedRow && clickedRow.classList.contains("selected")) {
            clickedRow.classList.remove("selected")
            return
        }
        this.clearSelections()

        if (clickedRow) {
            clickedRow.classList.add("selected")
        }
    },

    clearSelections() {
        document.querySelectorAll(".selected").forEach((el) => {
            el.classList.remove("selected")
        })
        this.selectedColumns = []
    },
    selectNthColumn(columnIndex, table) {
        // Get the table element if a selector was passed
        if (typeof table === "string") {
            table = document.querySelector(table)
        }

        if (!table || !(table instanceof HTMLTableElement)) {
            return []
        }

        const rows = Array.from(table.rows)
        const result = []

        rows.forEach((row) => {
            if (row.classList.contains("header-row")) {
                // Skip header rows
                return;
            }
            const cells = Array.from(row.cells)
            let currentColumnIndex = 0

            for (let i = 0; i < cells.length; i++) {
                const cell = cells[i]
                const colspan = parseInt(cell.getAttribute("colspan")) || 1

                // Check if this cell covers our target column
                if (currentColumnIndex <= columnIndex && columnIndex < currentColumnIndex + colspan) {
                    result.push(cell)
                    break
                }

                currentColumnIndex += colspan
            }
        })
        return result
    },
}))
